import { generateClient } from "aws-amplify/api";
import { createLesson } from "../../../graphql/mutations";
import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import LessonForm from "../common/LessonForm";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

const AddLesson = () => {
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const initialFormState = useMemo(() => ({
    title: "",
    description: "",
    content: "",
    order: 0,
    duration: 0,
    survey: "",
  }), []);
  const client = useMemo(() => generateClient(), []);
  const navigate = useNavigate();

  const handleSave = async (lesson) => {
    setLoading(true);
    try {
      await client.graphql({
        query: createLesson,
        variables: {
          input: {
            title: lesson.title,
            description: lesson.description,
            content: lesson.content,
            order: parseInt(lesson.order),
            duration: lesson.duration,
            survey: lesson.survey,
          },
        },
      });
      // Navigate to lessons page with success message
      navigate('/settings/lessons', { 
        state: { 
          successMessage: 'Lección creada exitosamente' 
        } 
      });
    } catch (error) {
      setAlertMessage("Error creating lesson.");
      setAlertSeverity("error");
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const renderAlert = (severity, message, onClose) => (
    <Alert severity={severity} onClose={onClose} sx={{ marginBottom: 2, width: '100%' }}>
      <AlertTitle>{severity === 'success' ? 'Success' : 'Error'}</AlertTitle>
      {message}
    </Alert>
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      height="100vh"
      paddingTop={2}
    >
      {alertMessage && renderAlert(alertSeverity, alertMessage, () => setAlertMessage(""))}
      {loading ? (
        <CircularProgress />
      ) : (
        <LessonForm
          initialFormState={initialFormState}
          onSave={handleSave}
          onBack={handleBack}
          title="Add Lesson"
        />
      )}
    </Box>
  );
};

export default AddLesson;